<motif-modal-title>
  <h3 class="motif-body1-default-regular m-0">
    {{
      this.action === 'Add'
        ? this.AddTaskConstants.Headers.AddTitle.Name
        : this.AddTaskConstants.Headers.EditTitle.Name
    }}
  </h3>
  <button type="button" class="modal-close-btn" aria-label="Close modal" [motif-modal-close]="true">
    <motif-icon
      class="motif-modal-header-close-icon"
      var="--navigation-Ic-Close-48px"
      aria-hidden="true"></motif-icon>
  </button>
</motif-modal-title>

<motif-modal-content>
  <div class="right-slide-model-wrapper">
    <div
      class="d-flex flex-column gap-4 align-items-start justify-content-start">
      <div
        class="d-flex flex-column gap-1 align-items-start justify-content-start w-100">
        <motif-form-field class="w-100">
          <label motifLabel
            >{{ this.AddTaskConstants.Headers.TaskName.Name }}*</label
          >
          <input
            motifInput
            labelPosition="inside"
            type="text"
            [(ngModel)]="taskName"
            aria-label="Task Name"
            maxlength="150"
            [required]="true" />
        </motif-form-field>

        <div class="description-char-count">
          {{ taskName.length || 0 }} / 500
        </div>
      </div>
      <div class="sa-task-config-wrapper">
        <div class="sa-task-config-body w-25">
          <motif-toggle-switch
            name="toggleSwitch"
            [(ngModel)]="toggleValue"
            prelabel="Human"
            postlabel="Agent"
            class="pb-10"
            (change)="onToggleSelection($event)"></motif-toggle-switch>

          <div
            class="d-flex flex-column gap-1 align-items-start justify-content-start w-100">
            <motif-form-field class="w-55">
              <label motifLabel>{{
                this.AddTaskConstants.Headers.AssignedTo.Name
              }}</label>
              <motif-select
                name="assignedTo"
                labelPosition="inside"
                aria-label="Select assignee"
                [(ngModel)]="selectedAssignee"
                selectTitle="Select assignee"
                placeholder=""
                [disabled]="!toggleValue"
                [filter]="true"
                [compareWith]="compareAssignee"
                (selectionChange)="onAssigneeToSelection($event)">
                <ng-container *ngFor="let option of dropdownOptions">
                  <motif-option [value]="option">
                    {{ option.value }}
                  </motif-option>
                </ng-container>
              </motif-select>
            </motif-form-field>
          </div>
        </div>
      </div>

      <div
        class="d-flex flex-column gap-1 align-items-start justify-content-start w-100">
        <motif-form-field class="w-55">
          <label motifLabel>Select Due Date</label>
          <motif-select
            name="selectDueDate"
            labelPosition="inside"
            aria-label="Select Due Date"
            [(ngModel)]="selectedDueDateOption"
            placeholder=""
            (selectionChange)="onDueDateSelection($event)">
            <ng-container *ngFor="let dd of dueDateOptions">
              <motif-option [value]="dd">
                {{ dd.label }}
              </motif-option>
            </ng-container>
          </motif-select>
        </motif-form-field>
      </div>
      <div
        class="d-flex flex-column gap-1 align-items-start justify-content-start w-100">
        <motif-form-field class="w-55">
          <label motifLabel>GTPw Task</label>
          <motif-select
            name="gtpwTask"
            labelPosition="inside"
            aria-label="Select GTPw Task"
            [(ngModel)]="selectedGTPwTaskOption"
            placeholder=""
            (selectionChange)="onGTPwTaskSelection($event)">
            <ng-container *ngFor="let g of gtpwTaskOptions">
              <motif-option [value]="g" [disabled]="g.isAssociated">
                <span [class.gtpw-associated-task]="g.isAssociated">{{
                  g.label
                }}</span>
              </motif-option>
            </ng-container>
          </motif-select>
        </motif-form-field>
      </div>
      <motif-toggle-switch
        name="fileUploadToggle"
        [(ngModel)]="fileUploadEnabled"
        prelabel="File Upload"
        class="pt-2"></motif-toggle-switch>
      <div
        class="d-flex flex-column gap-1 align-items-start justify-content-start w-100">
        <motif-form-field class="w-100">
          <label motifLabel>{{ this.AddTaskConstants.Prompt.Name }}</label>
          <textarea
            motifInput
            labelPosition="inside"
            type="text"
            [(ngModel)]="prompt"
            rows="20"
            maxlength="255"
            style="min-height: 200px"
            placeholder="Enter a description..."
            aria-label="Description"></textarea>
        </motif-form-field>

        <div class="description-char-count">
          {{ prompt.length || 0 }} / 5000
        </div>
      </div>
      <div
        class="d-flex flex-column gap-1 align-items-start justify-content-start w-100">
        <motif-form-field class="w-100">
          <label motifLabel>{{
            this.AddTaskConstants.Milestone.Name
          }}</label>
          <input
            motifInput
            labelPosition="inside"
            type="text"
            [(ngModel)]="milestoneName"
            [readonly]="true"
            aria-label="deliverable" />
        </motif-form-field>
      </div>
    </div>
  </div>
</motif-modal-content>

<motif-modal-actions>
  <button
    motifButton
    motif-modal-close
    color="secondary"
    aria-label="Cancel"
    role="button">
    {{ this.AddTaskConstants.ButtonTexts.CancelButton }}
  </button>

  <button
    motifButton
    color="primary"
    aria-label="Create"
    (click)="onCreate()"
    [disabled]="!taskName || taskName.trim().length === 0"
    role="button">
    {{ this.AddTaskConstants.ButtonTexts.CreateButton }}
  </button>
</motif-modal-actions>
